/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m19.6377 6.346 2.4361-.8123.4257-.4257-.0073-2.6077-2.8406.0008-8.8773 8.7727-1.241-1.2411-.001-.0009a2.5005 2.5005 0 0 0-3.528.0003l-.0007.0007-3.7703 3.7669a2.494 2.494 0 0 0-.7296 1.7625c0 .6602.2618 1.2933.7277 1.7604l.0024.0024 5.5016 5.4458a2.4995 2.4995 0 0 0 3.503.0259l3.5321-3.9354.0286-.0286a2.4939 2.4939 0 0 0-.0001-3.5258l-1.249-1.249 2.262-2.2621.8114-2.4372 2.2614-.7525.7529-2.26ZM24 5.3049l-.0099-3.5985a.7984.7984 0 0 0-.2269-.4759.7988.7988 0 0 0-.4744-.2303l-3.8321.001a.7854.7854 0 0 0-.6532.2293l-8.0229 7.9283-.1886-.1885a4.0003 4.0003 0 0 0-5.647 0L1.173 12.7386a3.9938 3.9938 0 0 0 0 5.6471l5.5035 5.4476a4 4 0 0 0 5.647 0l3.5362-3.94a3.9936 3.9936 0 0 0 0-5.6469l-.1885-.1885 1.3191-1.3191a.8056.8056 0 0 0 .1926-.3123l.6265-1.8817 1.8826-.6264a.8043.8043 0 0 0 .5052-.506l.6265-1.8807 1.8816-.6275a.7805.7805 0 0 0 .3121-.193l.7533-.7532A.7996.7996 0 0 0 24 5.3048ZM6.8232 15.2374a.25.25 0 0 1 .3536 0l2.5857 2.5858a.25.25 0 0 1 0 .3535l-.5857.5858a.2499.2499 0 0 1-.3536 0l-2.5858-2.5858a.25.25 0 0 1 0-.3535l.5858-.5858Zm4 1.5251-2.5858-2.5858c-.6834-.6834-1.7914-.6834-2.4749 0l-.5857.5858c-.6835.6835-.6835 1.7915 0 2.4749l2.5857 2.5858c.6834.6834 1.7915.6834 2.4749 0l.5858-.5858c.6834-.6834.6834-1.7914 0-2.4749Z"
    clipRule="evenodd"
  />,
  'MenuOnPremKeys'
);
